<template>
    <div class="soundlab block">
        <b-row>
<!--          <div class="d-flex soundlab__title">-->
<!--            <p class="font__futura-pt-bold">VIDEO</p>-->
<!--          </div>-->
            <b-col>

                <iframe src="https://player.vimeo.com/video/829988221?h=a365c84166" frameborder="0" allow="autoplay; fullscreen; picture-in-picture" allowfullscreen></iframe>
                <div class="video-wrapper">
                    <p class="client">Client:</p>
                    <p class="client__title">MG</p>
                    <p class="prod">/ Prod.:</p>
                    <p class="prod__title">REPUBLIC GROUP</p>
                    <p class="music">/ Music:</p>
                    <p class="music__title">ZOMBLAZE</p>
                </div>
                <iframe src="https://player.vimeo.com/video/648539755?h=a365c84166" frameborder="0" allow="autoplay; fullscreen; picture-in-picture" allowfullscreen></iframe>
                <div class="video-wrapper">
                    <p class="client">Client:</p>
                    <p class="client__title">LIBERTY BANK GEORGIA</p>
                    <p class="prod">/ Prod.:</p>
                    <p class="prod__title">LEAVINGSTONE</p>
                    <p class="music">/ Music:</p>
                    <p class="music__title">ZOMBLAZE</p>
                </div>
            </b-col>
            <b-col>
<!--              <iframe src="https://player.vimeo.com/video/672288936?h=1270164cf5" frameborder="0" allow="autoplay; fullscreen; picture-in-picture" allowfullscreen></iframe>-->
<!--              <div class="video-wrapper">-->
<!--                <p class="client">Client:</p>-->
<!--                <p class="client__title">KIFÜ</p>-->
<!--                <p class="prod">/ Prod.:</p>-->
<!--                <p class="prod__title">ADMIRAL FILM</p>-->
<!--                <p class="prod">/ Director:</p>-->
<!--                <p class="prod__title">KICKASS FACTORY</p>-->
<!--                <p class="music">/ Music:</p>-->
<!--                <p class="music__title">ZOMBLAZE</p>-->
<!--              </div>-->
                <iframe src="https://player.vimeo.com/video/648495785?h=7a2d5e6599"  frameborder="0" allow="autoplay; fullscreen; picture-in-picture" allowfullscreen></iframe>
                <div class="video-wrapper">
                    <p class="client">Client:</p>
                    <p class="client__title">SERENE UNDERWEAR</p>
                    <p class="prod">/ Prod.:</p>
                    <p class="prod__title">RADBARBRAVES</p>
                    <p class="music">/ Music:</p>
                    <p class="music__title">PLANETMALCOLM</p>
                </div>
                <iframe src="https://player.vimeo.com/video/648500795?h=bf752e518c" frameborder="0" allow="autoplay; fullscreen; picture-in-picture" allowfullscreen></iframe>
                <div class="video-wrapper">
                    <p class="client">Client:</p>
                    <p class="client__title">GENERAL ELECTRIC</p>
                    <p class="prod">/ Prod.:</p>
                    <p class="prod__title">DERENGO ANIM.</p>
                    <p class="music">/ Music:</p>
                    <p class="music__title">ZOMBLAZE</p>
                </div>
            </b-col>
        </b-row>
    </div>
</template>

<script>
    export default {
        name: "Video.vue",
        computed: {
            language: function () {
                return this.$store.getters.language;
            }
        },
    }
</script>

<!--p class="client">Client:</p>-->
<!--<p class="client__title">PETAL</p>-->
<!--<p class="prod">/ Prod.:</p>-->
<!--<p class="prod__title">XY</p>-->
<!--<p class="music">/ Music:</p>-->
<!--<p class="music__title">ZOMBLAZE</p>-->
<style scoped>
    .video-wrapper{
        display: flex;
        margin-bottom: 20px;
    }

    .video-wrapper .client{
        font-family:  futura-book-std, Serif;
        font-size: 9pt;
        letter-spacing: 1pt;
        margin-right: 4px;
    }

    .video-wrapper .client__title{
        font-family: futura-std-heavy, Serif;
        font-size: 9pt;
        letter-spacing: 0.5pt;
        margin-right: 5px;
    }

    .video-wrapper .prod{
        font-family:  futura-book-std, Serif;
        font-size: 9pt;
        letter-spacing: 1pt;
        margin-right: 4px;
    }

    .video-wrapper .prod__title{
        font-size: 9pt;
        letter-spacing: 0.5pt;
        font-family: futura-std-heavy, Serif;
        margin-right: 4px;
    }
    .video-wrapper .music{
        font-family:  futura-book-std, Serif;
        font-size: 9pt;
        letter-spacing: 1pt;
        margin-right: 4px;
    }

    .video-wrapper .music__title{
        font-size: 9pt;
        letter-spacing: 0.5pt;
        font-family: futura-std-heavy, Serif;
    }

    .col iframe:nth-child(1){
      /*margin-bottom: 30px;*/
    }
    .col__text .text{
        font-size: 16pt;
    }
    .col__text{
        padding-right: 140px;
    }
    .soundlab__title{
        margin-bottom: 20px;
    }
    .soundlab__title p{
      font-size: 22pt;
      letter-spacing: 2px;
      color: var(--asan-dark-grey);
    }
    img{
        width: 450px;
    }

    iframe{
        width: 530px;
        height: 300px;
    }
</style>